<template>
  <div class="orderDetail">
    <!-- 查看详情 -->
    <template v-if="!type">
      <div class="title">收货信息</div>
      <div class="address orderInfo">
        <div>
          <span>收货人：</span>
          {{
            data['7gohkizhpuyntjkg'] && data['7gohkizhpuyntjkg'].length > 0
              ? data['7gohkizhpuyntjkg'][0].value
              : ''
          }}
        </div>
        <div>
          <span>联系方式：</span>
          {{ data['9hsjp14robmaesii'] }}
        </div>
        <div>
          <span>收货地址：</span>
          {{
            data['3ysepdqjbyoaa9vv'] && data['3ysepdqjbyoaa9vv'].length > 0
              ? data['3ysepdqjbyoaa9vv'].map((el) => el.value).join('')
              : ''
          }}
          {{ data.scb2igdb9zvhdqok }}
        </div>
      </div>
      <div class="title">详细信息</div>
      <div class="orderInfo">
        <div>
          <span>下单人：</span>
          {{
            data.fnivxgmxe1bvqxol
              ? data.fnivxgmxe1bvqxol.map((el) => el.value).join('/')
              : ''
          }}
        </div>
        <div>
          <span>下单科室：</span>
          {{
            data.em9eprun6yuwfr7e && data.em9eprun6yuwfr7e.length > 0
              ? data.em9eprun6yuwfr7e[0].map((el) => el.value).join('/')
              : ''
          }}
        </div>
        <div>
          <span>备注：</span>
          {{ data.r2fzg7pqwr8czptv }}
        </div>
        <div>
          <span>总集备注：</span>
          {{ data['3o5b1cmlyxziweqz'] }}
        </div>
      </div>
    </template>
    <div class="title">
      商品清单
      <span>订单号：{{ data['5rh34ajk852uufsx'] }} </span>
      <img @click="copyToClipboard()" src="../../assets/img/copy.png" alt="" />
    </div>
    <div class="cartTableHeader">
      <span>商品信息</span>
      <span v-if="!type">单价</span>
      <span>数量</span>
      <span v-if="!type">合计</span>
      <span v-if="type">
        {{ type === 'returnGoods' ? '退货' : '换货' }}数量
      </span>
    </div>
    <ul class="orderList">
      <li v-for="item in productList" :key="'order' + item.id">
        <div class="orderDetail">
          <img
            :src="
              item['mnkt8dkjryhvdej3'] && item['mnkt8dkjryhvdej3'].length > 0
                ? item['mnkt8dkjryhvdej3'][0].url
                : ''
            "
            alt="商品图片"
          />
          <div class="goodsName">
            <p
              v-if="
                item['whfmbyuc1i2pavi4'] && item['whfmbyuc1i2pavi4'].length > 0
              "
            >
              {{ item['whfmbyuc1i2pavi4'][0].value }}
            </p>
          </div>
          <span v-if="!type">
            {{ item.rojkudmmvpzinpar ? '￥' + item.rojkudmmvpzinpar : 0 }}
          </span>
          <span>
            {{ item.mcuilzaudpe3shlc }}
            {{
              item.kq1qbbk7dulmlghs && !type ? `(${item.kq1qbbk7dulmlghs})` : ''
            }}
          </span>
          <span v-if="!type">
            {{ '￥' + item.nvbfzg88gv88hnt9 || 0 }}
          </span>
          <span v-if="type">
            <el-input-number
              v-if="type === 'returnGoods'"
              v-model="item.mbvjcurb6r0ckynw"
              type="number"
              placeholder="请输入"
              :max="item.mcuilzaudpe3shlc"
              :controls="false"
            ></el-input-number>
            <el-input-number
              v-else
              v-model="item.me6d75ufdtk3amaq"
              type="number"
              placeholder="请输入"
              :max="item.mcuilzaudpe3shlc"
              :controls="false"
            ></el-input-number>
          </span>
        </div>
      </li>
    </ul>
    <div class="remark" v-if="data.r2fzg7pqwr8czptv && !type">
      <div class="title">备注</div>
      <span>
        {{ data.r2fzg7pqwr8czptv }}
      </span>
    </div>
    <el-form :model="form" label-width="80px" v-if="type">
      <div class="title">售后物流及状态</div>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            :label="`${type === 'returnGoods' ? '退货' : '换货'}方式`"
            required
          >
            <el-select v-model="form.way" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="`${type === 'returnGoods' ? '退货' : '换货'}说明`"
            required
          >
            <el-input
              v-model="form.instructions"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <template v-if="form.way === 2">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="收货人">
              <el-select v-model="form.consignee" disabled placeholder="请选择">
                <el-option
                  v-for="item in aggregateAddress"
                  :key="item.id"
                  :label="item.dg3wysizdducq39m"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系方式">
              <el-input
                v-model="form.consigneePhone"
                disabled
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="收货地址">
              <el-input
                v-model="form.consigneeAddress"
                disabled
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <div class="title">寄件人信息</div>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="寄件人" required>
            <el-select
              v-model="form.sender"
              placeholder="请选择"
              @change="changeAddress"
            >
              <el-option
                v-for="item in myAddress"
                :key="item.id"
                :label="item.mdbcej4opshigmrs"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系方式">
            <el-input
              v-model="form.senderPhone"
              disabled
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="所在地区">
            <el-cascader
              v-model="form.senderArea"
              :options="city"
              :props="props"
              placeholder="请选择"
              disabled
            ></el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="详细地址">
            <el-input
              v-model="form.senderAddress"
              disabled
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="footer">
      <div v-if="data.p6zxciihiw61mebe && !type">
        <span>订单金额：</span>{{ '￥' + data.p6zxciihiw61mebe }}
      </div>
      <div v-else-if="type">
        <el-button type="primary" @click="confirm()">
          {{ type === 'returnGoods' ? '退货' : '换货' }}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { detailOnline, children, online, postOnline } from '@/api/platform'
import city from '@/util/city'
export default {
  data () {
    return {
      id: '',
      data: {},
      type: '',
      productList: [],
      form: {
        way: '', // 退货方式
        instructions: '', // 退货说明
        // 自行寄回
        consignee: '',//收货人
        consigneePhone: '',//收货人手机号
        consigneeAddress: '',//收货人地址
        // 上门取件
        sender: '', // 寄件人
        senderPhone: '', // 寄件人手机号
        senderArea: '', // 寄件人所在地区
        senderAddress: '', // 寄件人详细地址
      },
      options: [
        { value: 1, label: '上门取件' },
        { value: 2, label: '自行寄回' }
      ],
      aggregateAddress: [], //总集地址
      myAddress: [],
      city,
      props: {
        label: 'name',
        value: 'id'
      }
    }
  },
  components: {},
  created () {
    this.id = this.$route.params.id;
    this.detailOnline()
    // returnGoods 退货 barter 换货
    let type = this.$route.query.type
    if (type) {
      this.type = type
      this.getsAggregateAddress()
      this.getMyAddress()
    }
  },
  computed: {},
  mounted () { },
  methods: {
    // 获取总集地址
    async getsAggregateAddress () {
      const { result } = await online({
        form_head_uuid: '2fec51904d384887a819622a9975675b',
        page: 1,
        limit: 20
      })
      this.aggregateAddress = result
      if (result && result.length > 0) {
        this.$set(this.form, 'consignee', result[0].id)
        this.$set(this.form, 'consigneePhone', result[0].lw5lmjwlsaz0vzuu)
        this.$set(this.form, 'consigneeAddress', result[0].fm0kblhuu2evs4rv)
      }
    },
    // 获取我的地址
    async getMyAddress () {
      const { result } = await online({
        form_head_uuid: '0f5b2fde26c04882a5d6c5c885a30a3f',
        page: 1,
        limit: 20,
        keyword: '',
        select_option: '',
      })
      this.myAddress = result
    },
    changeAddress (e) {
      let obj = this.myAddress.find(el => el.id === e)
      this.$set(this.form, 'senderPhone', obj.xejhteu0ub3fd3eh)
      this.$set(this.form, 'senderArea', obj.b3ccmzbfyzlwy9sc.map(el => el.id))
      this.$set(this.form, 'senderAddress', obj['9simp0sjii9s0m33'])
    },
    // 复制订单号
    async copyToClipboard () {
      // 创建输入框元素
      const oInput = document.createElement('input');
      // 将想要复制的值
      oInput.value = this.data['5rh34ajk852uufsx'];
      // 页面底部追加输入框
      document.body.appendChild(oInput);
      // 选中输入框
      oInput.select();
      // 执行浏览器复制命令
      document.execCommand('Copy');
      // 弹出复制成功信息
      this.$message({
        message: '文本已复制到剪贴板',
        type: 'success'
      });
      // 复制后移除输入框
      oInput.remove();
    },
    async detailOnline () {
      const { result } = await detailOnline({
        form_head_uuid: "58a2be48484e436dbbb28fd778406de6",
        id: this.id,
      })
      this.data = result
      this.children()
    },
    async children () {
      const { result } = await children({
        page: 1,
        limit: 20,
        field_uuid: '00f98dceac054e8fb727092a99fc5a3d',
        form_head_uuid: '25a23d706f0e465c9ad89c333a841459',
        record_id: this.id
      })
      this.productList = result
    },
    async confirm () {
      let params = {}
      let form_head_uuid = ''
      const { productList, type, data: { id } } = this
      const { way, instructions, sender, senderPhone, senderArea, senderAddress, consignee, consigneePhone, consigneeAddress } = this.form
      if (!way) return this.$message.error(`请选择${type === 'returnGoods' ? '退' : '换'}货方式`)
      if (!instructions) return this.$message.error(`请输入${type === 'returnGoods' ? '退' : '换'}货说明`)
      if (!sender) return this.$message.error('请选择寄件人')
      if (this.type === 'returnGoods') {
        form_head_uuid = '30cfd060adfe11ee81ef0242321230b4'
        params = {
          irpxqkcdtusqiy2y: [id],
          indtkil4tvvff0ie: way === 1 ? '99152472-0949-4a28-89fc-61e8ddffaac3' : '4baade9e-2402-4ffd-9d57-74c1abc800cc',// 退货方式 上门取件/自行寄回
          ky4zxdehqi6ofpap: instructions,// 退货说明
          // 上门取件
          hkfwaidbg4mywpks: [sender],// 寄件人
          tpqk8ilierx76okc: senderPhone, // 手机
          h4taz2eavvajozrm: senderArea,// 所在地区
          gw5nzk6ycd5osq1g: senderAddress,// 详细地址
          // 自行寄回
          '5ei3icz5dttawswz': [consignee],// 总集地址
          d3q1oslyqeyggjei: consigneePhone,//联系方式
          qc638rrzbxa1trrx: consigneeAddress,//地址
          e7praxhjq8v5d8tr: productList.map(el => ({
            tlztdbj3bxchs5vi: el.whfmbyuc1i2pavi4.map(el => el.id),
            '6vxr6cjuplgkisse': el.mcuilzaudpe3shlc,
            mbvjcurb6r0ckynw: el.mbvjcurb6r0ckynw
          })),// 退货列表
        }

      } else {
        form_head_uuid = '01941b9eae0811ee879f0242321230b4'
        params = {
          a12n4mmhiv5zcziz: [id],
          indtkil4tvvff0ie: way === 1 ? '99152472-0949-4a28-89fc-61e8ddffaac3' : '4baade9e-2402-4ffd-9d57-74c1abc800cc',// 退货方式 上门取件/自行寄回
          ky4zxdehqi6ofpap: instructions,//换货说明
          //上门取件
          edx2y56vqrptfdk8: [sender],//寄件人
          twlzszggqs0hlzoj: senderPhone,//手机
          lx6cxkbpuo6osmry: senderArea,//所在地区
          rgxdenukluveemcq: senderAddress,//详细地址
          // 自行寄回
          ildcp7argfzmpygt: [consignee],// 总集地址
          axbtnlg6uvsm8ovd: consigneePhone, //联系方式
          oa4tnu9d1wkvifsb: consigneeAddress,//地址
          xixx4qsuefovkdiw: productList.map(el => ({
            tlztdbj3bxchs5vi: el.whfmbyuc1i2pavi4.map(el => el.id),
            '6vxr6cjuplgkisse': el.mcuilzaudpe3shlc,
            me6d75ufdtk3amaq: el.me6d75ufdtk3amaq
          })),// 换货列表
        }
      }
      await postOnline({
        form_head_uuid,
        ...params
      })
      this.$message({
        message: '提交成功',
        type: 'success'
      })
      setTimeout(() => {
        this.$router.go(-1);
      }, 1000)
    },
  },
}
</script>
<style lang='less' scoped>
@import '../../assets/css/var.less';
.orderDetail {
  padding: 30px 0;
  .title {
    font-weight: bold;
    font-size: 14px;
    color: #333;
    margin-bottom: 15px;
    border-left: 3px solid @thirdColor;
    padding-left: 6px;
    line-height: 12px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    span {
      font-weight: normal;
      margin-left: 10px;
    }
    img {
      width: 15px;
      margin-left: 5px;
      cursor: pointer;
    }
  }
  .address {
    border: 1px solid #f0f0f0;
  }
  .orderInfo {
    padding: 20px;
    margin-bottom: 30px;
    div {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-size: 12px;
      color: #666;
      line-height: 28px;
      span {
        color: #999;
        width: 60px;
        text-align: right;
        margin-right: 10px;
      }
    }
  }
  .cartTableHeader {
    width: 100%;
    height: 40px;
    background-color: #fafafa;
    border: 1px solid @borderColor;
    color: #666;
    font-size: 14px;
    line-height: 40px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    span {
      // display: inline-block;
      flex: 1;
      box-sizing: border-box;
      line-height: 40px;
      padding: 0 10px;

      &:first-child {
        text-align: center;
        flex-shrink: 0; /* 禁止自动缩小 */
        flex-grow: 0; /* 禁止自动增长 */
        flex-basis: 538px; /* 设置固定基础大小 */
      }
    }
  }
  .orderList {
    width: 100%;
    li {
      border: 1px solid @borderColor;
      border-top: none;
      font-size: 13px;
      .orderHeader {
        background-color: #f1f1f1;
        height: 40px;
        line-height: 40px;
        padding: 0 5px;
        background: #f2f7ff;
        border: 1px solid #f0f0f0;
        .orderTime {
          font-weight: 600;
        }
        .orderId,
        .state {
          margin-left: 10px;
        }
      }
      .orderDetail {
        background: #fbfcff;
        width: 100%;
        height: 100%;
        padding: 20px 0;
        position: relative;
        overflow: hidden;
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #666;
        padding-left: 10px;
        img {
          width: 80px;
          height: 80px;
          display: inline-block;
          // padding-left: 10px;
        }
        .goodsName {
          width: 448px;
          vertical-align: top;
          height: 84px;
          font-size: 14px;
          padding-left: 20px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
        }
        span {
          flex-shrink: 0;
          display: inline-block;
          vertical-align: top;
          width: 180px;
          height: 85px;
          line-height: 85px;
          display: flex;
          align-content: center;
          flex: 1;
          box-sizing: border-box;
          padding: 0 10px;
        }
      }
    }
  }
  .remark {
    margin-top: 20px;
    span {
      font-size: 14px;
    }
  }
  .footer {
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;
    div {
      color: @thirdColor;
      font-size: 18px;
      font-weight: bold;
      display: flex;
      justify-content: center;
      align-items: center;
      span {
        color: #666;
        font-size: 12px;
      }
    }
  }
  .el-form {
    margin-top: 20px;
    .el-select,
    .el-cascader {
      width: 100%;
    }
  }
}
/deep/ .el-input.is-disabled .el-input__inner {
  background-color: #fff !important;
  color: #606266;
}
.el-input-number {
  display: flex;
  justify-content: center;
  align-items: center;
}
/deep/.el-input-number .el-input__inner {
  text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/pages/client/OrderDetail.vue